export default {
  name: 'pop-up'
}
